import { render, staticRenderFns } from "./NsAddressUs.vue?vue&type=template&id=571b0582&scoped=true&"
import script from "./NsAddressUs.vue?vue&type=script&lang=js&"
export * from "./NsAddressUs.vue?vue&type=script&lang=js&"
import style0 from "./NsAddressUs.vue?vue&type=style&index=0&lang=scss&module=%24x&"
import style1 from "./NsAddressUs.vue?vue&type=style&index=1&id=571b0582&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$x"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "571b0582",
  null
  
)

export default component.exports